export default __webpack_public_path__ + "static/media/clean_success.b82a9502.mp3";